<template lang="pug">
  .c-list-cont
    .c-list-title {{ title }}
    ul.padding-list
      li.list-item(:key="index" v-for="(item, index) in projectsDashboard[name]" @click="viewProject(item)")
        .customer-name {{ item.project_name }}
        .from-now(:style="`background: ${setColorFromNow(setFromNow(item.created_at))};`") {{ setFromNow(item.created_at) }}
      vm-button.button-more(v-if="selectedCustomerIdDashboard > 0 & projectsDashboard[name].length > 4" type="line" @click="goCancelled") see more...
</template>

<script>
import moment from 'moment'
import Loader from '@/components/aditionals/Loader.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('Dashboard')

export default {
  name: 'RecentInfiniteListCancelled',
  components: {
    Loader
  },
  data: () => ({
    currentPage: 0,
    busy: false,
    loading: true
  }),
  props: {
    title: {
      type: String,
      default: 'Cancelled'
    },
    name: {
      type: String,
      default: 'cancelled'
    },
    status: {
      type: Number,
      default: 5
    }
  },
  async created () {
    this.loading = false
  },
  methods: {
    viewProject (project) {
      this.$router.push(`/projects/${project.id}/general`)
    },
    setFromNow (date) {
      return moment(date).fromNow()
    },
    setColorFromNow (fromNow) {
      if (fromNow.includes('day') || fromNow.includes('second') || fromNow.includes('minute') || fromNow.includes('hour')) {
        return 'rgb(23, 201, 100)'
      } else if (fromNow.includes('week')) {
        return 'rgb(255, 130, 0)'
      } else {
        return 'rgb(237, 28, 36)'
      }
    },
    goCancelled () {
      this.$router.push(`/cancelled/customer/${this.selectedCustomerIdDashboard}`)
    }
  },
  computed: {
    ...mapGetters([
      'projectsDashboard',
      'selectedCustomerIdDashboard'
    ])
  }
}
</script>

<style lang="scss" scoped>
.c-list-cont {
  background: white;
  border-radius: 10px;
  min-height: 50vh;
  max-height: calc(100vh - 390px);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: content-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.c-list-title {
  display: block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: sticky;
  background: white;
  top: 0;
  left: 0;
  box-sizing: content-box;
  padding: 10px 25px;
  z-index: 999;
}
ul {
  list-style-type: none;
}
.list-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: content-box;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.list-item:hover {
  background: #eeeeee;
}
.p-img-cont {
  background: #ED1B24;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  flex-shrink: 0;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    width: 85%;
    height: 85%;
    border: 2px solid white;
    background: #e4e4e4;
    border-radius: 50%;
    box-sizing: content-box;
  }
  .no-logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.customer-name {
  // font-weight: bold;
  font-size: 11px;
  letter-spacing: -0.02rem;
  line-height: 0.9rem;
}
button {
  border: 0 !important;
}
.padding-list {
  padding: 0px 15px 10px 15px;
}
.from-now {
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.6rem;
  display: inline;
  background: #4498E0;
  color: white;
  border-radius: 50px;
  padding: 5px 10px;
}
.button-more {
  width: 100%;
  margin: 10px 0px;
}
</style>
